import React, { useState, useEffect } from 'react';
// import './MarqueeBanner.css'; 

const MarqueeBanner = () => {
  const [marqueeText, setMarqueeText] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMarqueeBanner = async () => {
      try {
        const response = await fetch('https://admin.riymay.com/api/v1/admin/marquee-banner');
        if (!response.ok) {
          throw new Error('Failed to fetch marquee banner');
        }
        const data = await response.json();
        
        if (data.success && data.marqueeBanner.length > 0) {
          setMarqueeText(data.marqueeBanner[0].marqueeBannerText);
        }
      } catch (err) {
        setError(err.message);
        console.error('Error fetching marquee banner:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchMarqueeBanner();
  }, []);

  if (loading) return null; // Or a loading spinner
  if (error) return null; // Or error message

  return (
    <div className="marquee-container">
      <div className="marquee-text">
        {marqueeText}
      </div>
    </div>
  );
};

export default MarqueeBanner;